export default __webpack_public_path__ + "static/media/celebrate.82efa8e1.gif";